interface OptionalExtrasCatalogue {
    addons: readonly unknown[];
    isSuccess: boolean;
    isPlaceholderData: boolean;
}

// Only a loaded, current-product catalogue proves there are no extras; anything else keeps them.
export const configurationSubtitle = ({ addons, isSuccess, isPlaceholderData }: OptionalExtrasCatalogue): string => {
    const hasNoOptionalExtras = isSuccess && !isPlaceholderData && addons.length === 0;

    return hasNoOptionalExtras
        ? 'Please configure the services for the selected product.'
        : 'Please configure the services and optional extras for the selected product.';
};
